import React, { Component } from "react";

class StatusBar extends Component {
  state = { width: 370 };

  componentDidMount() {
    if (window.innerWidth < 600) {
      this.setState({ width: window.innerWidth - 40 });
    }
  }

  render() {
    const { completedCount, totalCount } = this.props;
    const completedPercent = (completedCount / totalCount) * 100;
    const colorPercentCalc = (completedPercent * this.state.width) / 100;
    return (
      <div
        className="status-bar"
        style={{
          borderLeft: `${colorPercentCalc}px solid #02ab31`,
        }}
      />
    );
  }
}

export default StatusBar;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/StatusBar.js